declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY?.trim();
let loader: Promise<void> | null = null;

const loadRecaptcha = () => {
  if (!siteKey || window.grecaptcha) return Promise.resolve();
  if (loader) return loader;

  loader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('No pudimos cargar el control de seguridad.'));
    document.head.appendChild(script);
  });
  return loader;
};

export const getRecaptchaToken = async (action: 'login' | 'register'): Promise<string | undefined> => {
  if (!siteKey) return undefined;
  await loadRecaptcha();
  if (!window.grecaptcha) throw new Error('El control de seguridad no está disponible.');

  return new Promise((resolve, reject) => {
    window.grecaptcha?.ready(() => {
      window.grecaptcha?.execute(siteKey, { action }).then(resolve).catch(reject);
    });
  });
};

export const isRecaptchaEnabled = Boolean(siteKey);
